module.exports = __webpack_public_path__ + "static/media/templates-icon.bc85c337.svg";